export default __webpack_public_path__ + "2b9a89bbb8c942d9b2b3cc5ab76db684.png";